// extracted by mini-css-extract-plugin
module.exports = {"root":"Question_root__1_cor","question":"Question_question__3mAmQ","description":"Question_description__1CNke"};